import { useCallback } from 'react'
import { useFeatureFlags } from '@fs/zion-flags'
import { useSlsDispatchContext } from '@fs/zion-sls'
import { useR2DispatchContext } from '../../../providers/r2Provider/R2Context'
import {
  useSharedBrowserDispatchContext,
  useSharedBrowserStateContext,
} from '../../../../shared/providers/sharedBrowserProvider/SharedBrowserContext'

export default function useSetReferenceFocusedIndex() {
  const r2Dispatch = useR2DispatchContext()
  const sharedBrowserState = useSharedBrowserStateContext()
  const sharedBrowserDispatch = useSharedBrowserDispatchContext()
  const slsDispatch = useSlsDispatchContext()
  const { rip_sharedImageViewer_viewedIndicator: viewedIndicatorFlag } = useFeatureFlags([
    'rip_sharedImageViewer_viewedIndicator',
  ])

  return useCallback(
    (value) => {
      r2Dispatch({ type: 'SET_REFERENCE_FOCUSED_INDEX', value })
      const newReferenceArk = sharedBrowserState.thumbnails?.[value]?.ark
      if (newReferenceArk) {
        slsDispatch({ type: 'ADD_ARKS_TO_LOAD', value: [newReferenceArk] })
        // Mark the reference image viewed so its "viewed" badge shows in the split-screen ribbon/grid.
        // Gated behind the viewed-indicator flag: this dispatch exists only for that feature, so it
        // stays dormant when the flag is off (the badge render in R2Image is gated by the same flag).
        if (viewedIndicatorFlag.isOn) {
          sharedBrowserDispatch({ type: 'MARK_IMAGE_VIEWED', value: newReferenceArk })
        }
      }
    },
    [r2Dispatch, slsDispatch, sharedBrowserState.thumbnails, sharedBrowserDispatch, viewedIndicatorFlag.isOn]
  )
}
